/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

//Jacques Bega
//hook that grabs insurance company info given a list of company codes
//to preserve query uniqueness a list of associated insurance (can be hazard and/or PMI/MIP)
import { QueryFunctionContext, useQueries } from '@tanstack/react-query';
import { fetchMiscPayeeInfo } from '../queryFunctions';

const useMiscPayeeInfo = (payeeNumbers: Set<string>, token: string, id: string) => {
  return useQueries({
    queries: [...payeeNumbers].map((payeeNumber, index) => ({
      queryKey: [index, payeeNumbers, token, id],
      queryFn: ({ signal }: QueryFunctionContext) => fetchMiscPayeeInfo(signal, token, payeeNumber),
      refetchOnWindowFocus: false,
    })),
    combine: (results) => {
      return {
        data: results.map((result) => result.data),
        status: results.some((result) => result.isPending)
          ? 'pending'
          : results.some((result) => result.isError)
            ? 'error'
            : 'success',
        error: results.filter((result) => result.isError).map((result) => result.error),
      };
    },
  });
};

export default useMiscPayeeInfo;
